export const BACKEND_PROCESS_TYPES = {
    EVIDENCE_PACKAGE: 'evidencePackage',
    RESUBMISSION_GUIDANCE: 'resubmissionGuidance',
    INTERVIEW_QUESTIONS: 'interviewQuestions',
    UNITS_RELATIONSHIP_MATRIX: 'unitsRelationshipMatrix',
    UNIT_OUTCOME_DETAILS: 'unitOutcomeDetails',
    INTERVIEW_TRANSCRIPT: 'interviewTranscript',
    INTERVIEW_TRANSCRIPT_SEGMENTATION: 'interviewTranscriptSegmentation'
};
